import { ButtonDataType, CommonSlideDataType } from "@/shared/types";
import { ButtonVariantType } from "@/shared/components";
import { Slide, Slider, SliderSlide } from "../directusTypes";
import { getImageData } from "./utils";
import { getButtonGroupButtons } from "./getButtonGroupButtons";

function getSlideButtons(slide: Slide): ButtonDataType[] {
  const buttonsFromGroup = getButtonGroupButtons(slide.block_button_group);
  if (buttonsFromGroup.length > 0) {
    return buttonsFromGroup;
  }

  const label = slide.button_label?.trim();
  const url = slide.button_url?.trim();
  if (!label || !url) {
    return [];
  }

  return [
    {
      variant: ButtonVariantType.default,
      children: label,
      href: url,
    },
  ];
}

const mapSlides = (
  directusSlidesArr: number[] | SliderSlide[]
): CommonSlideDataType[] =>
  directusSlidesArr
    .map((slide) => {
      if (typeof slide === "number") return;
      const { slides_id } = slide;
      return typeof slides_id === "object" && slides_id !== null
        ? {
            id: String(slides_id.id ?? ""),
            headline: slides_id.headline ?? "",
            description: slides_id.description ?? "",
            image: getImageData(slides_id.image),
            buttons: getSlideButtons(slides_id),
          }
        : null;
    })
    .filter((item) => !!item);

const getSlides = (slidesArray: Slider["slides"]): CommonSlideDataType[] =>
  typeof slidesArray?.[0] === "object" ? mapSlides(slidesArray) : [];

export const getSliderSlides = (
  directusSlider: Slider | number | null
): CommonSlideDataType[] =>
  !!directusSlider &&
  typeof directusSlider === "object" &&
  "slides" in directusSlider
    ? getSlides(directusSlider.slides)
    : [];
